const isDateObject = obj => {
  const res = Object.prototype.toString.call(obj) === '[object Date]'
  return res
}

export default isDateObject
